ace.define("ace/snippets/yaml",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="yaml"})


//////////////////
// WEBPACK FOOTER
// ./node_modules/brace/snippets/yaml.js
// module id = 115
// module chunks = 0